<!-- A persistent live region: changes (a new count, a cleared message) are announced, not only the first. -->
<div aria-live="polite" class="app-message-field">
  @if (message) {
    <p [class]="severity" class="alert" role="alert">{{ message }}</p>
  } @else {
    <!-- Same line height and margins as the alert, so a message appearing does not move what follows. -->
    <p class="cl-p-small mt-3">&nbsp;</p>
  }
</div>
